// extracted by mini-css-extract-plugin
export default {"hsStarCompleted":"_3-ScoreSubmitStep_hsStarCompleted__KDIiC","hsStarCompletedCol":"_3-ScoreSubmitStep_hsStarCompletedCol__vBHu0"};